<div class="smsNotification">
  <h3 class="smsNotification__title">SMSが届かない!? そんなときは…</h3>
  <p class="smsNotification__description">
    以下に当てはまらないか、一度ご確認ください
  </p>

  <ul class="smsNotification__list">
    <li>1. 入力した電話番号に間違いがある</li>
    <li>2. 通信環境が不安定</li>
    <li>3. SMSを受信拒否設定にしている</li>
    <li>4. 短い間に何度もリクエストを送信した</li>
  </ul>

  <div class="smsNotification__link">
    <img
      class="smsNotification__linkIcon"
      src="assets/icons/question.svg"
      alt="ヘルプリンク"
    />
    <a href="{{ smsHelpUrl }}" target="_blank" rel="noopener"
      >SMSが届かない場合の対処法はこちら</a
    >
  </div>
</div>
